import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Ocorrencia } from '../models/ocorrencia';
import { EtapaOcorrencia } from '../models/etapa-ocorrencia';
import { NotaFiscalOcorrencia } from '../models/nota-fiscal-ocorrencia';

@Injectable({
  providedIn: 'root'
})
export class OcorrenciaService {

  constructor(private http: HttpClient) { }

  consultarComPaginacao(
    paginaAtual,
    qtdRegistros,
    campoOrdenacao,
    orientacaoOrdenacao,
    idCupom?: string,
    tipoFiltro?: number,
    status?: number[],
    idFuncionario?: number,
    idCliente?: number,
    idTipo?: number,
    inicio?: Date,
    fim?: Date,
    idOcorrencia?: string,
    idFornecedor?: number,
    idSetor?: number,
    numeroNotaFiscal?: string,
    idVendedor?: number,
    prioridade?: number,
    etapaOcorrencia?: number
  ) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('tipoFiltro', tipoFiltro ? tipoFiltro.toString() : '0');

    if (idFuncionario) {
      parametros = parametros.set('idFuncionario', idFuncionario.toString());
    }

    if (idFornecedor) {
      parametros = parametros.set('idFornecedor', idFornecedor.toString());
    }

    if (idCupom) {
      parametros = parametros.set('idCupom', idCupom.toString());
    }

    if (idCliente) {
      parametros = parametros.set('idCliente', idCliente.toString());
    }

    if (idTipo) {
      parametros = parametros.set('idTipo', idTipo.toString());
    }

    if (!!status && status.length) {
      parametros = parametros.set('status', status.toString());
    }

    if (inicio) {
      parametros = parametros.set('inicio', typeof inicio !== 'string' ? inicio.toISOString() : inicio);
    }

    if (fim) {
      parametros = parametros.set('fim', typeof fim !== 'string' ? fim.toISOString() : fim);
    }

    if (idOcorrencia) {
      parametros = parametros.set('idOcorrencia', idOcorrencia);
    }

    if (idSetor) {
      parametros = parametros.set('idSetor', idSetor.toString());
    }

    if (numeroNotaFiscal) {
      parametros = parametros.set('numeroNotaFiscal', numeroNotaFiscal);
    }

    if (idVendedor) {
      parametros = parametros.set('idVendedor', idVendedor.toString());
    }

    if (prioridade !== null && prioridade !== undefined) {
      parametros = parametros.set('prioridade', prioridade.toString());
    }

    if (etapaOcorrencia !== null && etapaOcorrencia !== undefined) {
      parametros = parametros.set('etapaOcorrencia', etapaOcorrencia.toString());
    }

    return this.http.get<any>(globals.apiUrl + '/api/Ocorrencia/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorId(id: number) {
    return this.http.get<any>(globals.apiUrl + '/api/Ocorrencia/Buscar',
      { params: new HttpParams().set('id', id.toString()) });
  }

  consultarCabecalho(idCupom: string) {
    return this.http.get<any>(globals.apiUrl + '/api/Ocorrencia/BuscarCabecalho',
      { params: new HttpParams().set('idCupom', idCupom) });
  }

  salvar(ocorrencia: Ocorrencia) {
    return this.http.post(globals.apiUrl + '/api/Ocorrencia/Salvar', ocorrencia);
  }

  atualizarOpcoes(ocorrencia: Ocorrencia) {
    return this.http.post(globals.apiUrl + '/api/Ocorrencia/AtualizarOpcoes', ocorrencia);
  }

  alterarStatus(idOcorrencia: number, idStatus: number) {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('idOcorrencia', idOcorrencia.toString());
    queryParams = queryParams.append('status', idStatus.toString());

    return this.http.get<any>(globals.apiUrl + '/api/Ocorrencia/AlterarStatus',
      { params: queryParams });
  }

  exportarConsultaOcorrencias(
    paginaAtual,
    qtdRegistros,
    campoOrdenacao,
    orientacaoOrdenacao,
    idCupom?: string,
    tipoFiltro?: number,
    status?: number[],
    idFuncionario?: number,
    idCliente?: number,
    idTipo?: number,
    inicio?: Date,
    fim?: Date,
    idOcorrencia?: string,
    idFornecedor?: number,
    idSetor?: number,
    numeroNotaFiscal?: string,
    idVendedor?: number,
    prioridade?: number,
    etapaOcorrencia?: number
  ) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('tipoFiltro', tipoFiltro ? tipoFiltro.toString() : '0')
      .set('status', status.toString());

    if (idFuncionario) {
      parametros = parametros.set('idFuncionario', idFuncionario.toString());
    }

    if (idFornecedor) {
      parametros = parametros.set('idFornecedor', idFornecedor.toString());
    }

    if (idCupom) {
      parametros = parametros.set('idCupom', idCupom.toString());
    }

    if (idCliente) {
      parametros = parametros.set('idCliente', idCliente.toString());
    }

    if (idTipo) {
      parametros = parametros.set('idTipo', idTipo.toString());
    }

    if (inicio) {
      parametros = parametros.set('inicio', inicio.toISOString());
    }

    if (fim) {
      parametros = parametros.set('fim', fim.toISOString());
    }

    if (idOcorrencia) {
      parametros = parametros.set('idOcorrencia', idOcorrencia);
    }

    if (idSetor) {
      parametros = parametros.set('idSetor', idSetor.toString());
    }

    if (numeroNotaFiscal) {
      parametros = parametros.set('numeroNotaFiscal', numeroNotaFiscal);
    }

    if (idVendedor) {
      parametros = parametros.set('idVendedor', idVendedor.toString());
    }

    if (prioridade !== null && prioridade !== undefined) {
      parametros = parametros.set('prioridade', prioridade.toString());
    }

    if (etapaOcorrencia !== null && etapaOcorrencia !== undefined) {
      parametros = parametros.set('etapaOcorrencia', etapaOcorrencia.toString());
    }

    return this.http.get(globals.apiUrl + '/api/Ocorrencia/ExportarOcorrencias',
      { responseType: 'blob', params: parametros }
    );
  }

  consultarLogsOcorrencia(idOcorrencia) {
    return this.http.get<any>(globals.apiUrl + '/api/LogOcorrencia/BuscarLogsPorId',
      { params: new HttpParams().set('idOcorrencia', idOcorrencia) });
  }

  verificarSeExiste(idOcorrencia) {
    return this.http.get<any>(globals.apiUrl + '/api/LogOcorrencia/VerificarSeExiste',
      { params: new HttpParams().set('idOcorrencia', idOcorrencia) });
  }

  salvarEtapa(etapaStatus: EtapaOcorrencia) {
    return this.http.post(globals.apiUrl + '/api/Ocorrencia/SalvarEtapa', etapaStatus);
  }

  excluirEtapa(id) {
    return this.http.delete(globals.apiUrl + '/api/Ocorrencia/ExcluirEtapa',
      { params: new HttpParams().set('id', id) });
  }

  consultarPorIdEtapa(idSetor) {
    return this.http.get<any>(globals.apiUrl + '/api/Ocorrencia/BuscarEtapa',
      { params: new HttpParams().set('id', idSetor) });
  }

  consultarEtapas(idSetor?, idTipoOcorrencia?) {
    let parametros = new HttpParams();

    if (idSetor) {
      parametros = parametros.set('idSetor', idSetor.toString());
    }

    if (idTipoOcorrencia) {
      parametros = parametros.set('idTipoOcorrencia', idTipoOcorrencia.toString());
    }

    return this.http.get<EtapaOcorrencia[]>(globals.apiUrl + '/api/Ocorrencia/ListaEtapa',
      { params: parametros }
    );
  }

  consultarEtapasComPaginacao(descri, paginaAtual, qtdRegistros, campoOrdenacao, asc_desc, ativo, idSetor, idTipoOcorrencia) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', asc_desc)
      .set('descri', descri ? descri : '')
      .set('ativo', ativo.toString())
      .set('idSetor', idSetor ? idSetor.toString() : '')
      .set('idTipoOcorrencia', idTipoOcorrencia ? idTipoOcorrencia.toString() : '');

    return this.http.get<any>(globals.apiUrl + '/api/Ocorrencia/ListaEtapaPag',
      {
        params: parametros
      });
  }

  alterarEtapa(idOcorrencia: number, etapa) {
    let parametros = new HttpParams();
    parametros = parametros.append('idOcorrencia', idOcorrencia.toString());
    parametros = parametros.append('idEtapa', etapa);

    return this.http.get<any>(globals.apiUrl + '/api/Ocorrencia/AlterarEtapa',
      { params: parametros });
  }

  consultarLogsEtapaOcorrencia(idOcorrencia) {
    return this.http.get<any>(globals.apiUrl + '/api/LogOcorrencia/BuscarLogsEtapa',
      { params: new HttpParams().set('idOcorrencia', idOcorrencia) });
  }

  salvarNotaFiscalOcorrencia(notaFiscal) {
    return this.http.post(globals.apiUrl + '/api/Ocorrencia/SalvarNotaFiscalOcorrencia', notaFiscal);
  }

  consultarNotaFiscalOcorrenciaComPaginacao(paginaAtual, qtdRegistros, campoOrdenacao, asc_desc, idOcorrencia) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', asc_desc)
      .set('idOcorrencia', idOcorrencia ? idOcorrencia.toString() : '')

    return this.http.get<any>(globals.apiUrl + '/api/Ocorrencia/ListaNotaFiscalOcorrenciaPag',
      {
        params: parametros
      });
  }
}
